import { render, staticRenderFns } from "./ValueObjectGC.vue?vue&type=template&id=013c89e3&"
import script from "./ValueObjectGC.vue?vue&type=script&lang=js&"
export * from "./ValueObjectGC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports